import {
    REPLACE_CART,
    RESET_CART,
    SET_BLOCKED_CART,
    SET_CART_DRAGGING_TUTORIAL,
    SET_CART_ERROR,
    SET_CART_FOOTER_FIXED,
    SET_CART_PRODUCT_ERROR,
    SET_CART_TEMP_ITEM,
    SET_CART_TOOLTIP_ID,
    SET_IS_FETCHING_CART,
} from 'reducers/actions-types';
import localStorage from 'util/misc/local-storage';

const EMPTY_CART_STRUCT = {
    // we will need defaults in case we need to update
    // only partially our cart object
    wasFetched: true,
    wasReset: false,
    isEmpty: true,
    isFetching: false,
    cartError: null,
    productError: null,
    id: null,
    items: {},
    bagInfo: { total_bags: 0 },

    totalPrice: '0.00',
    totalItemsPrice: '0.00',
    shippingPrice: '0.00',
    customerDeliveryFee: '0.00',
    estimatedCustomerPrice: '0.00',
    promotions: [],
};

/**
 * Convert the categories into an object
 * @param {Object} initialState - The reducer initialState
 * @param {Object} params - The params for dispatch
 * @returns {{items: array, sumTotal: number}}
 */
export default function cartReducer(initialState = {
    tempItem: null, // A list of temporary items: Used when no zip is defined yet
    items: {},
    wasFetched: false,
    wasReset: false,
    isEmpty: true,
    isOpen: false,
    id: null,

    totalItemsPrice: '0.00',
    shippingPrice: '0.00',
    customerDeliveryFee: '0.00',
    estimatedCustomerPrice: '0.00',
    promotions: [],
    totalPrice: 0,

    hideDraggingTutorial: Boolean(localStorage.get('hideDraggingTutorial')) || false,
    isFetching: false,
    fetchingId: null,
    tooltipId: null,
    productError: null,
    cartError: null,
    promotionalCode: '',
    isFooterFixed: false,
    bagInfo: { total_bags: 0 }, // eslint-disable-line camelcase
}, {
    type,
    tempItem,
    items,
    id,
    wasFetched,
    isFetching,
    fetchingId,
    totalPrice,
    shippingPrice,
    totalItemsPrice,
    customerDeliveryFee,
    estimatedCustomerPrice,
    bagInfo,
    state,
    hideDraggingTutorial,
    tooltipId,
    isFooterFixed,
    promotions,
    error,
    promotionalCode,
}) {
    switch (type) {
        case REPLACE_CART:
            return Object.assign({}, initialState, {
                items: items.reduce((acc, item) => {
                    acc[item.product.id] = item;
                    return acc;
                }, {}),
                wasReset: false,
                productError: null,
                cartError: null,
                id,
                isEmpty: items.length === 0,
                // is ready will become true only the first time the cart will be fetched
                wasFetched: true,
                totalPrice,
                state,
                bagInfo,
                shippingPrice,
                totalItemsPrice,
                customerDeliveryFee,
                estimatedCustomerPrice,
                promotions,
                promotionalCode,
            });
        case SET_BLOCKED_CART:
            return Object.assign({}, initialState, EMPTY_CART_STRUCT, {
                id,
                state,
            });
        case SET_IS_FETCHING_CART:
            return Object.assign({}, initialState, {
                isFetching,
                fetchingId,
            });
        case SET_CART_DRAGGING_TUTORIAL:
            return Object.assign({}, initialState, { hideDraggingTutorial });
        case SET_CART_FOOTER_FIXED:
            return Object.assign({}, initialState, { isFooterFixed });
        case SET_CART_PRODUCT_ERROR:
            return Object.assign({}, initialState, { productError: error });
        case RESET_CART:
            return Object.assign({}, initialState, EMPTY_CART_STRUCT, {
                wasFetched: !!wasFetched,
                wasReset: true,
            });
        case SET_CART_ERROR:
            return Object.assign({}, initialState, EMPTY_CART_STRUCT, {
                cartError: error,
                id: initialState.id, // avoid to clean up the id
                wasReset: true,
            });
        case SET_CART_TOOLTIP_ID:
            return Object.assign({}, initialState, { tooltipId });
        case SET_CART_TEMP_ITEM:
            return Object.assign({}, initialState, { tempItem });
        default:
            return initialState;
    }
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/cart/index.js